import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LandingComponent } from './landing.component';

const routes: Routes = [{ path: '', component: LandingComponent }, { path: 'run-cycle', loadChildren: () => import('./run-cycle/run-cycle.module').then(m => m.RunCycleModule) }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule { }
